import React from 'react';
import PageGrid from '../../grids/PageGrid/PageGrid';
import {
  AttachmentsCountCell, BaseCell, BooleanCell, LinkCell,
} from 'shared/grids/Cells';
import format from 'date-fns/format';

const initialPage = { skip: 0, take: 10 };
const initialSort = [{ field: 'lastUpdatedAt', dir: 'desc' }];

const RequestsGrid = ({
  getData, renderRequestLink, isRead, displayReporter, displayAssignee,
}) => (
  <div>
    <PageGrid
      hasUnifiedTextSearch={false}
      hideActionsCell
      hideActionBar
      hideFiltersBar
      initialPage={initialPage}
      initialSort={initialSort}
      getData={getData}
      columns={[
        {
          field: 'orderId',
          title: 'Pro Number',
          cell: ({ dataItem, ...props }) => (
            <LinkCell to={`/orders/orders/${dataItem.orderId}`} openInNewTab {...props}>
              {`#${dataItem.orderId}`}
            </LinkCell>
          ),
        },
        {
          field: 'subject',
          title: 'Subject',
          cell: ({ dataItem, ...props }) => (
            <LinkCell to={renderRequestLink(dataItem)} openInNewTab {...props}>
              {!isRead(dataItem) ? <b>{dataItem.subject}</b> : (
                <>
                  {dataItem.subject}
                  {' '}
                </>
              )}

              {`#${dataItem.orderId}`}
            </LinkCell>
          ),
        },
        ...displayAssignee ? [{ field: 'reporterName', title: 'Reporter' }] : [],
        ...displayReporter ? [{ field: 'assigneeName', title: 'Assignee' }] : [],
        {
          field: 'lastUpdatedAt',
          title: 'Last Updated At',
          cell: ({ dataItem, ...props }) => (
            <BaseCell {...props}>
              {format(dataItem.lastUpdatedAt, 'MM/DD/YYYY HH:mm:ss')}
            </BaseCell>
          ),
        },
        {
          title: 'Driver Issue?',
          field: 'isDriverIssue',
          cell: ({ dataItem, ...props }) => (
            <BooleanCell
              {...props}
              className={dataItem.isDriverIssue ? 'is-driver-issue' : undefined}
              value={dataItem.isDriverIssue}
            />
          ),
        },
        {
          title: 'Pictures',
          field: 'imageCount',
          sortable: false,
          cell: ({ dataItem, ...props }) => (
            <AttachmentsCountCell {...props} count={dataItem.imageCount} />
          ),
        },
        {
          title: 'Status',
          field: 'status',
          cell: ({ dataItem, ...props }) => (
            <BaseCell {...props}>
              {dataItem.status}
            </BaseCell>
          ),
        },
      ]}
    />
  </div>
);

export default RequestsGrid;